import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserPreferenceContentComponent } from './user-preference-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InternationalPhoneNumberModule } from 'ng-phone-number';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InternationalPhoneNumberModule
  ],
  declarations: [UserPreferenceContentComponent],
  exports: [UserPreferenceContentComponent]
})
export class UserPreferenceContentModule { }
